import { render, staticRenderFns } from "./EditNews.vue?vue&type=template&id=47a62be2&scoped=true"
import script from "./EditNews.vue?vue&type=script&lang=js"
export * from "./EditNews.vue?vue&type=script&lang=js"
import style0 from "./EditNews.vue?vue&type=style&index=0&id=47a62be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a62be2",
  null
  
)

export default component.exports